<template>
	<svg id="down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<path d="M148.11,71.05,120.83,98.33V33.72a8.33,8.33,0,0,0-8.33-8.33h-25a8.33,8.33,0,0,0-8.33,8.33V98.33L51.89,71.05a8.32,8.32,0,0,0-11.78,0L22.44,88.72a8.34,8.34,0,0,0,0,11.78l71.67,71.67a8.34,8.34,0,0,0,11.78,0l71.67-71.67a8.34,8.34,0,0,0,0-11.78L159.89,71.05A8.32,8.32,0,0,0,148.11,71.05Z"/>
	</svg>
</template>

<script>
export default {
	name: "ArrowDown"
}
</script>
